import React from 'react';
import { Col, Input, Row, Checkbox, Card } from 'antd';
import { Controller, useFormContext } from 'react-hook-form';

const RestartOptions = () => {
  const { control, watch } = useFormContext();
  const restartCycleAfterFinish = watch('restartCycleAfterFinish');

  return (
    <Card className="card">
      <div>
        <Controller
          control={control}
          name="restartCycleAfterFinish"
          render={({ field: { value, onChange } }) => {
            return (
              <div>
                <Checkbox
                  checked={value.enabled}
                  onChange={e =>
                    onChange({
                      ...value,
                      enabled: e.target.checked,
                    })
                  }
                >
                  Restart after finish
                </Checkbox>

                {!!restartCycleAfterFinish.enabled && (
                  <>
                    <Row>
                      <Col span={12}>
                        <Input
                          addonBefore="Number of restarts (0 = unlimited)"
                          min={0}
                          type="number"
                          value={value.count}
                          onChange={e => {
                            onChange({
                              ...value,
                              count: parseFloat(e.target.value),
                            });
                          }}
                        />
                      </Col>

                      <Col span={12}>
                        <Input
                          addonBefore="Delay between runs (seconds)"
                          min={0}
                          type="number"
                          value={value.delay}
                          onChange={e => {
                            onChange({
                              ...value,
                              delay: parseFloat(e.target.value),
                            });
                          }}
                        />
                      </Col>
                    </Row>
                  </>
                )}
              </div>
            );
          }}
        />
      </div>
    </Card>
  );
};

export default RestartOptions;
